import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
  width: 100%;
  min-height: 100vh;
  padding: 6.75rem 1.25rem 7.5rem;
`;
